export function getSettings() {
  const policy = window?.SETTINGS?.hosts?.policy as string;
  return Object.freeze({
    isSignInPolicy: policy?.includes('_SignIn') ?? false,
    isResetMfa: policy?.includes('_ResetMfa') ?? false,
  });
}